import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const ProtectedRoute = ({ allowedRoles = [], children }) => {
    const user = useAuth();
    if (!user?.authorities?.length) {
        return <Navigate to="/403" replace />;
    }

    const isAuthorized = user.authorities.map(role => role.authority).some(role => allowedRoles.includes(role));

    if (!isAuthorized) {
        return <Navigate to="/403" replace />;
    }

    return children;
};

export default ProtectedRoute;
